import { IMG_BASE_URL } from "./misc";

export const COMPANY_DETAILS = {
    name: "Vahak",
    workspace: "Attic Space Trishul",
    address: "#12, 7th Cross Rd, Koramangala 1A Block, Koramangala 3 Block, Koramangala, Bengaluru, Karnataka 560034",
    addressLine1: "#12, 7th Cross Rd",
    addressLine2: "Koramangala 1A Block",
    addressLine3: "Koramangala 3 Block",
    addressLine4: "Bengaluru, Karnataka 560034",
    addressLocality: "Bengaluru",
    addressRegion: "KA",
    postalCode: "560034",
    addressCountry: "IN",
    telephone: "+91-8035738071",
    website: "https://www.vahak.in",
    stagingLink: "https://stagingapp.vahak.in",
    potentialActionTargetUrl: "https://www.vahak.in/marketplace/load",
    googleMapLink: "https://goo.gl/maps/oMThWRu6DvCui3uw8",
    googleMapEmbedLink:
        "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15554.647223964115!2d77.6325878!3d12.9294447!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x2ef61e2a187b7d36!2sVahak%20-%20Transport%20Marketplace%20App%20(Book%20Trucks%20%26%20Loads)!5e0!3m2!1sen!2sin!4v1643133299249!5m2!1sen!2sin",
    openHours: "Mon-Sat (9:00 AM - 9:00 PM)",
    logo: `${IMG_BASE_URL}/Vahak_Blue.png`
};
